import { motion } from "framer-motion";
import { useContext } from "react";
import { useMedia } from "react-use";
import styled, { useTheme } from "styled-components";
import { MenuOpenContext } from "../context/MenuOpenContext";
import { easings } from "../styles/utils";

const MenuMoverOuter = styled(motion.div)`
  height: 100%;
  flex: 1;
  overflow: hidden;
  box-shadow: 50px 20px 100px 0 rgba(0, 0, 0, 0.41);
  display: flex;
  flex-direction: column;
`;

const MenuMoverInner = styled(motion.div)`
  height: 100%;
  pointer-events: all;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const menuMoveOuterVariants = {
  open: {
    x: "calc(-100vw + 200px)",
    transition: { duration: 0.6, ease: easings.easeOutCubic },
  },
  closed: {
    x: 0,
    transition: { duration: 0.6, delay: 0.3, ease: easings.easeOutCubic },
  },
};

const menuMoveInnerVariants = {
  open: {
    x: "calc(100vw - 200px)",
    transition: { duration: 0.6, ease: easings.easeOutCubic },
  },
  closed: {
    x: 0,
    transition: { duration: 0.6, delay: 0.3, ease: easings.easeOutCubic },
  },
};

export const MainMenuMover: React.FC = ({ children }) => {
  const theme = useTheme();
  const isWide = useMedia(`(min-width: ${theme.breakpoints[1]})`);
  const { menuOpen } = useContext(MenuOpenContext);

  if (!isWide) {
    return <>{children}</>;
  }

  return (
    <MenuMoverOuter
      variants={menuMoveOuterVariants}
      animate={menuOpen ? "open" : "closed"}
    >
      <MenuMoverInner variants={menuMoveInnerVariants}>
        {children}
      </MenuMoverInner>
    </MenuMoverOuter>
  );
};
